export default __webpack_public_path__ + "static/03-0941f7fa521a3e7dc899bed70268c796.jpg";